import { object } from '@calendly/form/validation'

import { buildNameNotificationSchema, getCancellationPolicyValidation } from 'components/event_type_edit'
import { MANAGED_EVENT_TYPE } from 'constants/event_types'
import { useUpdateEventTypeMutation } from 'features/event_type_editor/api'
import { useGoBack } from 'features/event_type_editor/control_panel/use_go_back'
import { isAnyLocksEnabled } from 'services/event_type_locking'

import { formValuesToServerData, getInitialValues } from './config'
import { NotificationFields } from './notification_fields'
import { BaseSection } from '../base_section'

const useDefaultOnSubmit = (eventType) => {
  const [updateEventType, { error }] = useUpdateEventTypeMutation({ id: eventType.id })
  const goBack = useGoBack()

  const defaultOnSubmit = (attributes) => updateEventType({
    eventType,
    attributes,
    onSuccess: goBack,
  })

  return {
    defaultOnSubmit,
    error
  }
}

export const BaseNotificationSection = ({
  kind,
  eventType,
  description,
  skipDirtyCheck = false,
  externalError,
  onSubmit,
}) => {
  const { isMETParent } = eventType
  const { defaultOnSubmit, error } = useDefaultOnSubmit(eventType)
  const initialValues = getInitialValues(eventType, kind)
  const etLocked = !isMETParent && isAnyLocksEnabled(eventType, ['v3_notifications'])

  const validationSchema = getCancellationPolicyValidation().concat(object({
    [kind]: buildNameNotificationSchema(initialValues[kind]),
  }))

  return (
    <BaseSection
      etLocked={etLocked}
      externalError={externalError || error}
      formatValues={(values) => formValuesToServerData(values, kind)}
      initialValues={initialValues}
      isManaged={eventType.type === MANAGED_EVENT_TYPE}
      saveDisabled={etLocked}
      skipDirtyCheck={skipDirtyCheck}
      validationSchema={validationSchema}
      onSubmit={onSubmit || defaultOnSubmit}
    >
      <NotificationFields
        eventType={eventType}
        kind={kind}
        description={description}
      />
    </BaseSection>
  )
}
